import { enableMapSet, produce } from 'immer';
import { create } from 'zustand';

enableMapSet();

export type AppCacheType = {
  cache: Map<string, unknown>;
  get: <T>(key: string) => T;
  set: (key: string, value: unknown) => void;
};

export const useAppCache = create<AppCacheType>((set, get) => ({
  cache: new Map<string, unknown>(),
  get: <T>(key: string) => get().cache.get(key) as T,
  set: (key, value) => {
    set(
      produce((state: AppCacheType) => {
        state.cache.set(key, value);
      })
    );
  },
}));
